module.exports = __webpack_public_path__ + "components/flag/static/square/co-9eabda902f28604a23ef2ac6275adef6.svg";